// extracted by mini-css-extract-plugin
export default {"conferenceIcon_light":"xfaNBgHl","conferenceIcon_dark":"yhdK_v52"};